import React, { ReactNode } from 'react';
import cx from 'classnames';
import styles from './index.scss';

export interface TabTitleProps {
  className?: string;
  icon?: ReactNode;
  title: ReactNode;
  desc: ReactNode;
}

export const TabTitle = ({ className, icon, title, desc }: TabTitleProps) => {
  return (
    <div className={cx(styles.TabTitle, className)}>
      <div className={styles.TabTitleIcon}>{icon}</div>
      <div className={cx(styles.TabTitleInfo, className)}>
        <div>{title}</div>
        <div>{desc}</div>
      </div>
    </div>
  );
};
